import { TFunction } from 'i18next'

export const defaultError = (t: TFunction, name: string): string => t(`paymentMethod:errors.default.${name}`)
